module.exports = __webpack_public_path__ + "static/media/YF86_04.934145d8.jpg";